import { SearchTeam } from '../../00_modules/disposition/models';

export class SetTeamSearch {
    static readonly type = '[TeamSearch] Set Team Search';

    constructor(public searchTerm: string) {}
}

export class SetTeamSearchResult {
    static readonly type = '[TeamSearch] Set Team Search Result';

    constructor(public searchResult: SearchTeam[]) {}
}

export class ResetTeamSearch {
    static readonly type = '[TeamSearch] Reset Team Search';
}
